"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "dirty": true,
    "raw": "v2.2.1-18-g9f3b124-dirty",
    "hash": "g9f3b124",
    "distance": 18,
    "tag": "v2.2.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.2.1",
        "major": 2,
        "minor": 2,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "2.2.1"
    },
    "suffix": "18-g9f3b124-dirty",
    "semverString": "2.2.1+18.g9f3b124.dirty"
};
//# sourceMappingURL=version.js.map